import t from "./index.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const m = i(t);
export {
  m as initBatchTransmit
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/batch-transmit/index.js
// module id = 1223
// module chunks = 67